import { useState } from 'react';
import AssignCSCDrawer from '../drawers/AssignCSCDrawer';
import Panel from '~/components/Panel';

interface CSCOption {
    id: number;
    full_name: string;
    first_name?: string;
    last_name?: string;
}

interface Props {
    csc?: any | null;
    campaignId?: number | string;
    handleSaveCSC: (csc: CSCOption) => void;
    saving: boolean;
}
const CscBlock: React.FC<Props> = ({ csc, campaignId, handleSaveCSC, saving }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const bgColor = csc
        ? 'bg-[#e6f7f8] border-[#e6f7f8]'
        : 'bg-[#fdeaeb] border-[#fdeaeb]';

    // Convert csc prop to CSCOption format for the drawer
    const currentCSC: CSCOption | null = csc
        ? {
              id: csc.id || csc.person_id,
              full_name: csc.full_name || `${csc.first_name} ${csc.last_name}`,
              first_name: csc.first_name,
              last_name: csc.last_name,
          }
        : null;

    return (
        <>
            <Panel addClasses={`${bgColor} flex-1`}>
                <h2 className='text-[16px]/[24px] font-medium uppercase text-[#131212]'>
                    CSC
                </h2>
                <div
                    className={`text-[16px]/[24px] ${
                        csc ? 'font-bold' : ''
                    } text-[#131212] ${csc ? '' : 'italic'}`}
                >
                    {csc
                        ? `${csc.first_name} ${csc.last_name}`
                        : 'None Assigned'}
                </div>
                <div className='text-[16px]/[24px]'>
                    {!csc && (
                        <button
                            className='text-[#F02D3A]'
                            onClick={() => setIsDrawerOpen(true)}
                        >
                            Assign
                        </button>
                    )}
                    {csc && (
                        <button
                            className='text-[#00AEB3]'
                            onClick={() => setIsDrawerOpen(true)}
                        >
                            Reassign
                        </button>
                    )}
                </div>
            </Panel>
            <AssignCSCDrawer
                isOpen={isDrawerOpen}
                setIsOpen={setIsDrawerOpen}
                currentCSC={currentCSC}
                handleSaveCSC={handleSaveCSC}
                saving={saving}
            />
        </>
    );
};

export default CscBlock;
